import styled, { css } from "styled-components";
import { responsiveMap } from "../../../Grid/_utils/responsiveObserve";

export const _LandingHeaderMargauxMotinRoot = styled("div")(
  () => css`
    width: 100%;
    position: relative;
    overflow: hidden;

    .landing-section-base__head__top {
      z-index: 2;
    }

    .margaux-motin-animation {
      margin-top: -${208}px;
      transform: translateX(-128px) translateZ(0px);

      @media ${responsiveMap.mobile} {
        transform: translateX(18%) translateZ(0px);
        width: 100%;
        max-width: 386px;
        min-height: 200px;
        aspect-ratio: 193 / 197;
        margin: 0px auto;
        margin-top: 0px;
        margin-bottom: 90px;
      }

      video {
        @media ${responsiveMap.mobile} {
          transform: scale(1.5) translateZ(0px);
        }
      }
      img {
        @media ${responsiveMap.mobile} {
          transform: scale(1.3) translateZ(0px) translateX(13px);
        }
      }

      .margaux-motin-animation-content-decoration {
        position: absolute;
        top: 21%;
        right: 0px;
        transform: translateX(26%);
        max-width: 25%;

        @media ${responsiveMap.mobile} {
          position: absolute;
          top: 21%;
          left: 0px;
          transform: translateX(-38%);
          max-width: unset;
        }

        & img {
          width: 100%;
          max-width: 154px;
          height: auto;
          aspect-ratio: 1;
          object-fit: cover;

          @media ${responsiveMap.mobile} {
            transform: scaleX(-1) translateX(40%);
            max-width: 120px;
            width: 32%;
          }
        }
      }
    }

    .landing-section-base__head__middle__container {
      position: relative;
    }

    .margaux-motin-animation-content-decoration-2 {
      position: absolute;
      bottom: -10%;
      right: 0px;
      transform: translateX(0%);
      max-width: 45%;

      & img {
        width: 100%;
        max-width: 249px;
        height: auto;
        flex-shrink: 0;
        aspect-ratio: 249/347;
      }
    }

    .margaux-motin-bottom {
      margin: 0px auto 0px 0px !important;
      align-items: flex-start;
      text-align: left;

      @media ${responsiveMap.mobile} {
        align-items: center;
        text-align: left;
        margin: 0px auto !important;
      }
    }

    .margaux-motin-bottom-content {
      position: relative;

      .margaux-motin-bottom-content-decoration {
        position: absolute;
        top: 0;
        right: 22%;
        transform: translateY(-86%);
      }

      .margaux-motin-bottom-content-decoration-2 {
        display: flex;
        justify-content: flex-end;

        @media ${responsiveMap.mobile} {
          display: none;
        }

        & img {
          margin-top: -43px;
          margin-right: -31%;
        }
      }
    }

    .desktop-decoration {
      @media ${responsiveMap.mobile} {
        display: none !important;
      }
    }
  `
);
